export default {"src":"/_next/static/media/filled_close.cce0a76e.svg","height":25,"width":25};